module.exports = __webpack_public_path__ + "static/google_store@3x.3ed10a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/google_store@3x.jpg
// module id = 661
// module chunks = 193162123475590